import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';

export default function EmailModal({ isOpen, onClose }) {
  const [editableContent, setEditableContent] = useState({
    title: "عروض عيد الشكر في انتظارك!",
    heading: "عروض حصرية لعيد الشكر تبدأ قريباً!",
    description: "احتفل بموسم الامتنان مع صفقات شهية. عروضنا المختارة للعطلات على وشك الوصول - لا تفوت فرصة التوفير!",
    bannerText: "شحن مجاني على جميع الطلبات فوق 100 دولار",
    buttonText: "اكتشف ما هو قادم",
    bottomBannerText: "استخدم كود الخصم: 25OFF",
    companyName: "اسم الشركة",
    websiteUrl: "www.yourcompany.com"
  });

  const handleContentChange = (field, value) => {
    setEditableContent(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = () => {
    console.log('Updated content:', editableContent);
    onClose();
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                <div className="p-4">
                  {/* Top Banner */}
                  <div className="bg-black w-full py-2 text-center text-white text-sm">
                    <input
                      type="text"
                      value={editableContent.bannerText}
                      onChange={(e) => handleContentChange('bannerText', e.target.value)}
                      className="bg-transparent text-center w-full outline-none"
                      placeholder="Enter banner text"
                      dir="rtl"
                    />
                  </div>

                  <div className="p-8">
                    {/* Logo */}
                    <img 
                      src="https://i.ibb.co/YkwGqLQ/Screenshot-2024-11-14-at-3-38-45-PM-removebg-preview-1.png"
                      alt="Company Logo"
                      className="w-24 h-24 mx-auto mb-6"
                    />

                    {/* Main Heading */}
                    <div className="text-3xl font-bold text-center mb-6">
                      <input
                        type="text"
                        value={editableContent.heading}
                        onChange={(e) => handleContentChange('heading', e.target.value)}
                        className="w-full text-center bg-transparent outline-none"
                        placeholder="Enter main heading"
                        dir="rtl"
                      />
                    </div>

                    {/* Description */}
                    <div className="text-center text-gray-600 mb-8">
                      <textarea
                        value={editableContent.description}
                        onChange={(e) => handleContentChange('description', e.target.value)}
                        className="w-full text-center bg-transparent outline-none resize-none"
                        rows={3}
                        placeholder="Enter description"
                        dir="rtl"
                      />
                    </div>

                    {/* CTA Button */}
                    <div className="text-center">
                      <input
                        type="text"
                        value={editableContent.buttonText}
                        onChange={(e) => handleContentChange('buttonText', e.target.value)}
                        className="px-8 py-3 bg-black text-white rounded text-center"
                        placeholder="Enter button text"
                        dir="rtl"
                      />
                    </div>

                    {/* Product Grid */}
                    <div className="mt-12 grid grid-cols-2 gap-8">
                      <div className="text-center">
                        <img 
                          src="https://i.ibb.co/82xMFc1/NOV002-2-07abbaea-3e7d-4c61-8034-9d6593ae1833-1080x.webp"
                          alt="Product 1"
                          className="w-full h-64 object-contain mb-4"
                        />
                        <h3 className="font-medium">طقم أواني الطهي للمناسبات</h3>
                        <div className="flex items-center justify-center space-x-2">
                          <span className="line-through text-gray-500">35.00$</span>
                          <span className="font-bold">20.00$</span>
                          <span className="text-green-600">وفر 15.00$</span>
                        </div>
                        <button className="mt-2 border border-black px-4 py-1 text-sm">
                          تسوق الآن
                        </button>
                      </div>
                      <div className="text-center">
                        <img 
                          src="https://i.ibb.co/82xMFc1/NOV002-2-07abbaea-3e7d-4c61-8034-9d6593ae1833-1080x.webp"
                          alt="Product 2"
                          className="w-full h-64 object-contain mb-4"
                        />
                        <h3 className="font-medium">طقم أواني الطهي للمناسبات</h3>
                        <div className="flex items-center justify-center space-x-2">
                          <span className="line-through text-gray-500">30.00$</span>
                          <span className="font-bold">15.00$</span>
                          <span className="text-green-600">وفر 15.00$</span>
                        </div>
                        <button className="mt-2 border border-black px-4 py-1 text-sm">
                          تسوق الآن
                        </button>
                      </div>
                    </div>

                    {/* Bottom Banner */}
                    <div className="mt-12 bg-black text-white text-center py-4 text-sm">
                      <input
                        type="text"
                        value={editableContent.bottomBannerText}
                        onChange={(e) => handleContentChange('bottomBannerText', e.target.value)}
                        className="bg-transparent text-center w-full outline-none"
                        placeholder="Enter bottom banner text"
                        dir="rtl"
                      />
                    </div>

                    {/* Footer */}
                    <div className="mt-12 text-center">
                      <img 
                        src="https://i.ibb.co/YkwGqLQ/Screenshot-2024-11-14-at-3-38-45-PM-removebg-preview-1.png"
                        alt="Company Logo"
                        className="w-16 h-16 mx-auto mb-4"
                      />
                      <input
                        type="text"
                        value={editableContent.companyName}
                        onChange={(e) => handleContentChange('companyName', e.target.value)}
                        className="text-lg font-bold text-center w-full outline-none mb-4"
                        placeholder="Enter company name"
                        dir="rtl"
                      />
                      <div className="flex justify-center space-x-4 mt-4">
                        <a href="#" className="text-gray-600 hover:text-black">انستغرام</a>
                        <a href="#" className="text-gray-600 hover:text-black">فيسبوك</a>
                        <a href="#" className="text-gray-600 hover:text-black">بينتريست</a>
                        <a href="#" className="text-gray-600 hover:text-black">تيك توك</a>
                      </div>
                      <input
                        type="text"
                        value={editableContent.websiteUrl}
                        onChange={(e) => handleContentChange('websiteUrl', e.target.value)}
                        className="mt-4 text-gray-600 text-center w-full outline-none"
                        placeholder="Enter website URL"
                      />
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="bg-gray-50 px-4 py-3 sm:px-6 border-t border-gray-200">
                  <div className="flex justify-end space-x-3">
                    <button
                      type="button"
                      className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                      onClick={onClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="px-4 py-2 text-sm font-medium text-white bg-[#0049ac] rounded-md hover:bg-[#0049ac]/90"
                      onClick={handleSubmit}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}